import Vue from 'vue'
import ArgonDashboard from "./argon-dashboard/argon-dashboard";
Vue.use(ArgonDashboard);